




































import { defineComponent, ref } from '@vue/composition-api';
const name = 'ttam-target-summary-item';
export default defineComponent({
  name,
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup() {
    const showAll = ref(false);
    function toggleMore() {
      showAll.value = !showAll.value;
    }
    return {
      name,
      showAll,
      toggleMore,
    };
  },
});
